import { apiFetch } from './client';
import type { Project } from '$lib/types';

// GET /api/projects — session-scoped read (member: granted only, admin:
// all). POST /api/projects — session-scoped create (member OR admin; a
// member is auto-granted what they create and forced onto their own team
// server-side). Distinct from adminProjectsApi's /api/admin/projects, which
// is the admin-only full CRUD surface (edit/delete never lives here).
export const projectsApi = {
  list: () => apiFetch<{ results: Project[]; count: number }>('/projects'),
  create: (body: Record<string, unknown>) =>
    apiFetch<Project>('/projects', { method: 'POST', body: JSON.stringify(body) })
};
